(function (root, factory) {
  var engine = factory();
  if (typeof module === 'object' && module.exports) module.exports = engine;
  else root.YunicFilterEngine = engine;
})(typeof window !== 'undefined' ? window : this, function () {
  function list(value) { return Array.isArray(value) ? value : value ? [value] : []; }
  function size(value) {
    if (value.indexOf('"') !== -1) return value.replace(/"/g, ' in');
    if (/mm/.test(value)) return value;
    var numbers = value.match(/\d+(?:\.\d+)?/g);
    return numbers ? numbers.join(' × ') + ' ft' : value.trim();
  }
  function colors(value) {
    var aliases = { Royal:'Blue', Navy:'Blue', Charcoal:'Gray', Sand:'Beige', Merlot:'Red', Clay:'Brown', Multi:'Multicolor', 'Stars and Stripes':'Patterned', 'Navy Skulls':'Patterned' };
    return Array.from(new Set(value.split(/[/,&]/).map(function (v) { v = v.trim(); return aliases[v] || v; }).filter(Boolean)));
  }
  function prepare(data) {
    var attributes = {};
    Object.keys(data.attributes).forEach(function (key) { attributes[key] = list(data.attributes[key]); });
    attributes.type = [data.type];
    data.variants.forEach(function (variant) {
      var values = {};
      data.options.forEach(function (name, i) { values[name.toLowerCase()] = variant.options[i]; });
      variant.attributes = Object.assign({}, attributes);
      variant.attributes.availability = [variant.available ? 'In stock' : 'Out of stock'];
      if (values.color || values['net color']) variant.attributes.color = colors(values.color || values['net color']);
      if (values.size) {
        if (attributes.frame_size.length) variant.attributes.frame_size = [size(values.size)];
        else variant.attributes.product_size = [size(values.size)];
      }
      if (values['cage size']) variant.attributes.fit_size = [size(values['cage size'])];
      if (values['rod length']) variant.attributes.product_size = [size(values['rod length'])];
      if (values.width && values.length) variant.attributes.product_size = [values.width.replace(' ft', '') + ' × ' + values.length.replace(' ft', '') + ' ft'];
    });
    data.attributes = attributes;
    return data;
  }
  function variants(product, state, exclude) {
    return product.variants.filter(function (variant) {
      if (exclude !== 'price' && state.min != null && variant.price < state.min * 100) return false;
      if (exclude !== 'price' && state.max != null && variant.price > state.max * 100) return false;
      return Object.keys(state.filters).every(function (key) {
        var selected = state.filters[key];
        return key === exclude || !selected.length || list(variant.attributes[key]).some(function (value) { return selected.indexOf(value) !== -1; });
      });
    });
  }
  function matches(product, state, exclude) { return variants(product, state, exclude).length > 0; }
  function count(products, state, key, value) {
    var selected = Object.assign({}, state, { filters:Object.assign({}, state.filters) });
    selected.filters[key] = [value];
    return products.filter(function (p) { return matches(p, selected); }).length;
  }
  function values(products, key) {
    return Array.from(new Set(products.flatMap(function (p) { return p.variants.flatMap(function (v) { return list(v.attributes[key]); }); }))).sort(function (a,b) { return a.localeCompare(b, undefined, { numeric:true }); });
  }
  return { prepare:prepare, variants:variants, matches:matches, count:count, values:values, size:size, colors:colors };
});
